import mitt from 'mitt';
import Util from '@/helper/Utility.js';

export function PdpaModalController () {
    this.title = '';
    this.type = '';
    this.version = '';
    this.btnOk = '';
    this.btnCancel = '';
    this.busModal = mitt();

    this.alertModal = null;

    this.callbackOk = null;
    this.callbackCancel = null;

    //#region setter
    this.clearModal = function () {
        this.title = '';
        this.btnOk = '';
        this.btnCancel = '';
        this.callbackOk = null;
        this.callbackCancel = null;
        return this;
    };
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setType = function (type) {
        this.type = type;
        return this;
    };
    this.setVersion = function (version) {
        this.version = version;
        return this;
    };
    this.setBtnOk = function (btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setBtnCancel = function (btnCancel) {
        this.btnCancel = btnCancel;
        return this;
    };
    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function () {
        const config = {
            title: this.title,
            btnOk: this.btnOk,
            btnCancel: this.btnCancel
        };
        this.busModal.emit('show', config);
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };
    this.onClickCancel = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackCancel = callback;
        }
    },
    this.sendCallbackCancel = function(data) {
        if (Util.isFunction(this.callbackCancel)) {
            this.callbackCancel(data);
        }
    };
    //#endregion event
}